import clsx from "clsx";

const Loader = ({
  size = "md",
  text = "",
  fullScreen = false,
  inline = false,
  className = "",
}) => {
  const sizeClasses = {
    sm: "h-5 w-5 border-2",
    md: "h-8 w-8 border-[3px]",
    lg: "h-12 w-12 border-4",
  };

  const spinner = (
    <div
      className={clsx(
        "animate-spin rounded-full border-[#ead8c0] border-t-[#8B3A3A]",
        sizeClasses[size] || sizeClasses.md
      )}
      aria-hidden="true"
    />
  );

  if (inline) {
    return (
      <span
        className={clsx("inline-flex items-center gap-2 text-sm text-[#6b5b57]", className)}
        role="status"
        aria-live="polite"
      >
        {spinner}
        {text ? <span>{text}</span> : null}
      </span>
    );
  }

  if (fullScreen) {
    return (
      <div
        className={clsx(
          "fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#fffaf5]/90 backdrop-blur-sm",
          className
        )}
        role="status"
        aria-live="polite"
      >
        {spinner}
        {text ? <p className="mt-4 text-sm font-medium text-[#6b5b57]">{text}</p> : null}
      </div>
    );
  }

  return (
    <div
      className={clsx("flex flex-col items-center justify-center py-8", className)}
      role="status"
      aria-live="polite"
    >
      {spinner}
      {text ? <p className="mt-3 text-sm text-[#6b5b57]">{text}</p> : null}
    </div>
  );
};

export default Loader;